
<template>
    <el-dialog :title="textMap[title]" :visible.sync="dialogFormVisible">
        <el-form :model="form" ref="form" label-width="100px">
            <el-form-item label="类型编码" prop="dictCode" class="items" :rules="[{ required: true, message: '请输入类型编码', trigger: 'blur' }]">
                <el-input v-model="form.dictCode " placeholder="类型编码"></el-input>
            </el-form-item>
            <el-form-item label="类型名称" prop="dictName" class="items" :rules="[{ required: true, message: '请输入类型名称', trigger: 'blur' }]">
                <el-input v-model="form.dictName" placeholder="类型名称"></el-input>
            </el-form-item>
            <el-form-item label="备注信息" prop="dictTips" style="margin-top:20px">
                <el-input v-model="form.dictTips" placeholder="备注信息"></el-input>
            </el-form-item>
             <el-form-item>
                <el-button type="primary" @click="change_pwd('form')">提交</el-button>
                <el-button @click="resetForm('form')">取消</el-button>
            </el-form-item>
        </el-form>
    </el-dialog>
</template>
<script>
import {addObj,getObj,putObj} from '@/api/admin/dict'
import waves from '@/directive/waves/index.js' // 水波纹指令
import {objKeySort} from '@/util/ajaxsign'
  export default {
    data() {
      return {
         title : '',
            textMap: {
                update: '编辑字典',
                create: '创建字典'
            },
            dictId : '',
            dialogFormVisible : false,
            form: {
                dictCode:"",
                dictName:"",
                dictTips:"",
                dictValues:""
            }
      };
    },
    methods: {
      resetForm(formName) {
        this.$refs[formName].resetFields();
        this.dialogFormVisible = false;
      },
       //展示弹出层
        dialog(data,id){
            this.title = data;
            this.dialogFormVisible = true;
            if(id){
               this.handleUpdate(id)
            }
        },

        // 修改弹窗
        handleUpdate(id) {
            this.dictId = id;
            getObj(objKeySort({dictId:id})).then(response => {
                let dict = response.data.data;
                this.form.dictCode= dict.code;
                this.form.dictName= dict.name;
                this.form.dictTips= dict.tips;
            })
        },

        handleEmpty(){
            this.$refs.form.resetForm();
            this.dialogFormVisible = false;
        },



        cancel(formName) {
           // this.dialogFormVisible = false;
            console.log(this.$refs[formName])
            this.$refs[formName].resetFields();
        },

        //处理数据
        change_pwd(data){
            if(this.title == "create"){
                this.addObj(data)
            }else{
                this.update(data)
            }
        },
        addObj(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    addObj(objKeySort({code:this.form.dictCode,name:this.form.dictName,tips:this.form.dictTips})).then(() => {
                        this.$message({
                            title: '成功',
                            message: '创建成功',
                            type: 'success',
                            duration: 2000
                        })
                        this.$emit('refresh','');
                        this.resetForm('form');
                    })
                } else {
                    return false;
                }
            });
        },
        //修改
        update(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    putObj(objKeySort({id:this.dictId,code:this.form.dictCode, name:this.form.dictName,tips:this.form.dictTips})).then(() => {
                        this.$message({
                            title: '成功',
                            message: '修改成功',
                            type: 'success',
                            duration: 2000
                        })
                        this.$emit('refresh','');
                        this.resetForm('form');
                    })
                }
            })
        }
    }
  }
</script>
